import { render, staticRenderFns } from "./BrandsSidebarLinks.vue?vue&type=template&id=775434d2&scoped=true&"
import script from "./BrandsSidebarLinks.vue?vue&type=script&lang=js&"
export * from "./BrandsSidebarLinks.vue?vue&type=script&lang=js&"
import style0 from "./BrandsSidebarLinks.vue?vue&type=style&index=0&id=775434d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775434d2",
  null
  
)

export default component.exports